module.exports = __webpack_public_path__ + "img/activity_title.8c66f79f.png";